import React from "react";
import { OrganizationDetailsTable } from "./view/OrganizationDetailsTable";

function OrganizationDetailsTab(props) {
  const { organization } = props;

  return (
    <section className="organization-detail-section">
      <OrganizationDetailsTable organization={organization}/>
    </section>
  );
}

export { OrganizationDetailsTab };
